var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.92587 11.6573L0.834705 6.56612C0.522285 6.2537 0.522285 5.74717 0.834705 5.43475L5.92587 0.343578C6.23829 0.0311588 6.74483 0.0311588 7.05724 0.343578C7.36966 0.655998 7.36966 1.16253 7.05724 1.47495L3.33176 5.20043L12.6004 5.20043C13.0422 5.20043 13.4004 5.5586 13.4004 6.00043C13.4004 6.44226 13.0422 6.80043 12.6004 6.80043L3.33176 6.80043L7.05724 10.5259C7.36966 10.8383 7.36966 11.3449 7.05724 11.6573C6.74483 11.9697 6.23829 11.9697 5.92587 11.6573Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow-back.e549e290940669100d12ceca2facb177.svg";
export { ForwardRef as ReactComponent };